import { RouteCategory } from './interfaces/route.interface';

export const kSidebarRoutes = [
    {
        title: RouteCategory.ALERTS,
        links: [
            {
                link: '/alerts-stats',
                icon: 'alert-stats',
                label: 'alertsstats',
            },
            {
                link: '/alerts-manager/created',
                icon: 'alert-manager',
                label: 'alertsmanager',
            },
            { link: '/alerts', icon: 'alerts', label: 'alerts' },
            {
                link: '/alerts-technical',
                icon: 'alert-technical',
                label: 'alertstechnical',
            },
        ],
    },
    {
        title: RouteCategory.USER,
        links: [
            { link: '/notifications', icon: 'bell', label: 'notifications' },
            { link: '/patients', icon: 'patients', label: 'patients' },
            {
                link: '/admin-follow',
                icon: 'follow-admin',
                label: 'adminfollow',
            },
            {
                link: '/admin-notifications',
                icon: 'bell',
                label: 'adminnotifications',
            },
            { link: '/carestaff', icon: 'carestaff', label: 'carestaff' },
            {
                link: '/companies',
                icon: 'hospitals',
                label: 'companies',
            },
            { link: '/users', icon: 'user', label: 'users' },
        ],
    },
    {
        title: RouteCategory.OTHER,
        links: [
            { link: '/billing', icon: 'billing', label: 'billing' },
            { link: '/config', icon: 'config', label: 'config' },
            { link: '/kit', icon: 'device', label: 'installation' },
            {
                link: '/manage-profiles-users',
                icon: 'user',
                label: 'profiles-users',
            },
            {
                link: '/patient-binding',
                icon: 'admins-validation',
                label: 'patient-binding',
            },
            {
                link: '/journey-configuration',
                icon: 'study',
                label: 'journey-configuration',
            },
        ],
    },
];
